import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PersonalDetailsModal } from "./PersonalDetailsModal";
import { GENDER_OPTIONS } from "Constant/constants";

export const PersonalDetails = ({
  personalDetailsData,
  fetchData,
  isCurrentUserProfile,
}) => {
  const { t } = useTranslation();

  const [personalDetailsModal, setShowPersonalDetailsModal] = useState(false);

  const genderLabel =
    GENDER_OPTIONS.find(
      (option) => option.value === personalDetailsData?.gender
    )?.label || "";

  // Functions to toggle modals
  const togglePersonalDetailsModal = () => {
    setShowPersonalDetailsModal((prev) => !prev);
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex justify-content-between align-items-center gap-3 position-relative">
          <h4 className="mb-0 text-md font-semibold text-grey-800">
            {t("auth.viewProfile.personalDetails")}
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={() => togglePersonalDetailsModal()}
              >
                <i className="bx bx-pencil"></i> Edit
              </button>
            </div>
          )}
        </div>
        <div className="row gy-3">
          <div className="col-md-4 col-sm-6 co-12">
            <div className="">
              <label htmlFor="dateOfBirth" className="form-label mb-0">
                {t("common.label.dateOfBirth")}
              </label>
              <div className="text-sm font-semibold text-grey-800">
                {personalDetailsData?.dateOfBirth || ""}
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 co-12">
            <div className="">
              <label htmlFor="gender" className="form-label mb-0">
                {t("common.label.gender")}
              </label>
              <div className="text-sm font-semibold text-grey-800">
                {t(genderLabel)}
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 co-12">
            <div className="">
              <label htmlFor="nationality" className="form-label mb-0">
                {t("common.label.nationality")}
              </label>
              <div className="text-sm font-semibold text-grey-800">
                {personalDetailsData?.nationality || ""}
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 co-12">
            <div className="">
              <label htmlFor="address" className="form-label mb-0">
                {t("common.label.address")}
              </label>
              <div className="text-sm font-semibold text-grey-800">
                {personalDetailsData?.address || ""}
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 co-12">
            <div className="">
              <label htmlFor="currentCity" className="form-label mb-0">
                {t("common.label.currentCity")}
              </label>
              <div className="text-sm font-semibold text-grey-800">
                {personalDetailsData?.currentCity || ""}
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 co-12">
            <div className="">
              <label htmlFor="currentCountry" className="form-label mb-0">
                {t("common.label.currentCountry")}
              </label>
              <div className="text-sm font-semibold text-grey-800">
                {personalDetailsData?.currentCountry || ""}
              </div>
            </div>
          </div>
        </div>
      </div>

      {personalDetailsModal && (
        <PersonalDetailsModal
          show={personalDetailsModal}
          personalDetailsData={personalDetailsData}
          toggle={togglePersonalDetailsModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
